import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogueComponent } from 'src/app/components/confirmation-dialogue/confirmation-dialogue.component';
import { CameraServerService } from '../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { CameraViewDialogComponent } from '../dialogs/camera-view-dialog/camera-view-dialog.component';
import { ConfigService } from 'src/app/services/config.service';
import { SiteCamLiveViewsComponent } from '../dialogs/site-cam-live-views/site-cam-live-views.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppConstants, hasPrivilege } from 'src/app/shared/app-constants';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FootageDownloadComponent } from '../dialogs/footage-download/footage-download.component';
import { MoveSite } from '../dialogs/move-site/move-site';
import { IframeModalComponent } from 'src/app/iframe-modal/iframe-modal.component';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { ExportDeleteImportComponent } from '../dialogs/export-delete-import/export-delete-import.component';

export interface TableElement {
  id: number;
  potentialName: string;
  status: string;
  cameraCount: any;
  deviceCount: any;
}
@Component({
  selector: 'app-site-list',
  templateUrl: './site-list.component.html',
  styleUrls: ['./site-list.component.scss']
,
  standalone: false
})
export class SiteListComponent implements OnInit, AfterViewInit {
  searchTerms = new Subject<string>();
  searchSiteFilterValue: string = ''
  loading: boolean = false;
  displayedColumns: string[] = ['id', 'potentialName', 'status', 'farm', 'cameraCount', 'deviceCount', 'action'];
  dataSource = new MatTableDataSource<TableElement>([]);
  dataSourceArray: any;
  selection = new SelectionModel<TableElement>(true, []);
  totalRecords: number;
  pageSize: number = 10;
  pageNumber: number = 0;
  selectRow: any = [];
  selectAllRow: any = [];
  isDev = false;
  isMaskingEnabled: boolean = false;
  currentUser: any;
  editCameraConfig: boolean = false;
  cameraServerDetails: any = [];
  isFootageDownloadEnabled: boolean = false;
  isIcockpit: boolean = false;
  siteDownloadUrl: string = "";

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private router: Router,
    private ngbModalService: NgbModal,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    public configService: ConfigService,
    private authService: AuthenticationService,
    private googleAnalyticService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    const siteSearchValue = localStorage.getItem("siteSearchFilterVal") || '';
    this.searchSiteFilterValue = siteSearchValue || '';
    this.isMaskingEnabled = this.configService.isFeatureEnabled('masking');
    this.isFootageDownloadEnabled = this.configService.isFeatureEnabled('footageDownload');
    this.isIcockpit = this.configService.isFeatureEnabled('isIcockpit');
    this.checkCameraServerOldOrNew();
    this.getPagedData(this.pageSize, this.pageNumber, this.searchSiteFilterValue);
    this.getCurrentUser();
    this.applySiteFilter();
    this.siteDownloadUrl = this.camService.siteDumpAllExport(this.searchSiteFilterValue);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.pageNumber = this.paginator.pageIndex;
    this.pageSize = this.paginator.pageSize;
    this.sort.active;
    this.dataSource.sort = this.sort;
    this.sort.direction;
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  getCurrentUser() {
    if (hasPrivilege('edit camera configuration')) {
      this.editCameraConfig = true;
    }
  }

  getPagedData(pageSIze: any, PageIndex: any, searchvalue: string) {
    this.spinner.activate();
    this.loading = true;
    this.camService.searchSitesData(searchvalue, PageIndex, pageSIze).subscribe((response: any) => {
      if (response && response.success) {
        this.spinner.deactivate();
        this.loading = false;
        let newResponseData = response?.data?.site;
        const newCheckedCameraDetails = newResponseData?.map((item: any, index: any) => {
          this.cameraServerDetails?.map((cItem: any) => {
            if (cItem.platform == 'NEW_CAMERA_SERVER' && cItem?.potentialId == item?.vtigerPotentialId && !item['isNewCamServer']) {
              item['isNewCamServer'] = true;
            }
          });
          return item;
        });
        this.dataSource = new MatTableDataSource<any>(newCheckedCameraDetails);
        //this.dataSource = new MatTableDataSource<any>(response?.data?.site);
        this.totalRecords = response?.data?.totalRecords;
        this.dataSource.sort = this.sort;
      } else {
        this.spinner.deactivate();
        this.loading = false;
        this.toastr.error(response?.message || AppConstants.defaultErrorMessage);
      }
    }, err => {
      this.loading = false;
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
  }

  /** Check the Camera server is is Old camera server or New Camera server */
  checkCameraServerOldOrNew() {
    this.spinner.activate();
    this.loading = true;
    this.camService.checkPlateForm().subscribe((response: any) => {
      if (response && response.success) {
        this.spinner.deactivate();
        this.loading = false;
        this.cameraServerDetails = response?.data;
        this.getPagedData(this.pageSize, this.pageNumber, this.searchSiteFilterValue);
      } else {
        this.spinner.deactivate();
        this.loading = false;
        this.toastr.error(response?.message || AppConstants.defaultErrorMessage);
      }
    }, err => {
      this.loading = false;
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toastr.error(err.error.message, 'Error');
      } else {
        this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
  }

  /** Function call when user start searching site. */
  applySiteFilter() {
    this.searchTerms
      .pipe(debounceTime(1500), distinctUntilChanged())
      .subscribe((searchVal) => {
        localStorage.setItem("siteSearchFilterVal", this.searchSiteFilterValue);
        if (searchVal.length >= 3) {
          this.getPagedData(
            this.pageSize,
            0,
            this.searchSiteFilterValue
          );
          this.siteDownloadUrl = this.camService.siteDumpAllExport(this.searchSiteFilterValue);
        } else if (searchVal.length == 0) {
          this.getPagedData(
            this.pageSize,
            this.pageNumber,
            this.searchSiteFilterValue
          );
          this.siteDownloadUrl = this.camService.siteDumpAllExport(this.searchSiteFilterValue);
        }
      });
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /** Function call when user clear the search filter value. */
  clearSearchFilter() {
    this.searchSiteFilterValue = '';
    localStorage.setItem("siteSearchFilterVal", '');
    if (this.searchSiteFilterValue == '') {
      this.getPagedData(
        this.pageSize,
        this.pageNumber,
        this.searchSiteFilterValue
      );
    }
    this.siteDownloadUrl = this.camService.siteDumpAllExport(this.searchSiteFilterValue);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
    this.selectAllRow = this.selection.selected;
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: TableElement): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id}`;
  }

  // selectedCheckBoxRow(event: any, row: any) {
  //   event.stopPropagation();
  //   const newSelectedRow = this.selectRow;
  //   newSelectedRow.push(row)
  //   this.selectRow = newSelectedRow
  // }

  changePaging(event: any) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getPagedData(this.pageSize, this.pageNumber, this.searchSiteFilterValue);
  }

  selectedRow(event: any, row: any) {
    event.stopPropagation();
  }

  handleViewOrEdit(event: any, element: any) {
    event.stopPropagation();
    localStorage.setItem("selectedTab", '0');
    sessionStorage.setItem("siteData", JSON.stringify(element));
    sessionStorage.setItem("potentialId", element?.vtigerPotentialId);
    this.router.navigate([`/camera-server/sitelist/${element.vtigerPotentialId}`])
    /** On click we are creating event in Google Analytics */
    this.googleAnalyticService.event('Edit sites', element.potentialName, element.vtigerPotentialId)
    /** End of GA Service  */
  }

  addNewSite() {
    this.router.navigate(["/camera-server/add-sitelist"])
  }

  /** Remove Site */
  removeSites() {
    let sitePotentialId = "";
    this.selection?.selected?.map((item: any) => {
      sitePotentialId = item.potentialId;
    })
    let popupData = {
      title: "Delete Confirmation",
      message: `Are you sure you want to delete this ${this.selection?.selected?.length} ${(this.selection?.selected?.length <= 1) ? 'site?' : 'sites?'}`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }

    let dialoge = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialoge.componentInstance._data = popupData;
    dialoge.result.then(data => {
      if (data) { //this data return true if user click on Yes, and if No the return false
        this.spinner.activate();
        this.loading = true;
        this.camService.deleteSite(sitePotentialId).subscribe((response: any) => {
          if (response.success) {
            this.spinner.deactivate();
            this.loading = false;
            this.toastr.success(response?.messages[0]);
            this.getPagedData(this.pageSize, this.pageNumber, this.searchSiteFilterValue);
          } else {
            this.spinner.deactivate();
            this.loading = false;
            this.toastr.error(response?.messages[0] || AppConstants.defaultErrorMessage);
          }
        }, (err) => {
          this.spinner.deactivate();
          if (err && err.error && err.error.message && err.error.message.length > 0) {
            this.toastr.error(err.error.message, 'Error');
          } else {
            this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
          }
        })
      }
    })
  }

  /** Function is used for open cockpit 1 dialog modal */
  openCockpitDialog(iframeUrl: any) {
    this.dialog.open(IframeModalComponent, {
      panelClass: 'view-camera',
      width: '100%',
      height: '80%',
      data: { iframeUrl },
      disableClose: true
    });
    //sessionStorage.setItem("potentialId", element.vtigerPotentialId)
  }

  /** Function is used for open cancel site list */
  cancelSite(event: any) {
    this.router.navigate([`/camera-server/cancelled-site-list`])
  }

  /** Function is used for open moving site dialog modal */
  moveSiteDialog() {
    this.dialog.open(MoveSite, {
      panelClass: 'view-camera',
      width: '50%',
      data: { isEdit: false },
      disableClose: true
    });
    //sessionStorage.setItem("potentialId", element.vtigerPotentialId)
  }

  /** Camera List Dialog when user click on camera count in site table */
  openCameraListDialog(element: any) {
    this.dialog.open(CameraViewDialogComponent, {
      panelClass: 'view-camera',
      width: '100%',
      disableClose: true,
      data: { isDevice: false, potentialId: element.vtigerPotentialId, siteName: element.potentialName }
    });
    sessionStorage.setItem("potentialId", element.vtigerPotentialId)
  }

  /** Device List Dialog when user click on device count in site table */
  openDeviceListDialog(element: any) {
    // this.dialog.open(CameraViewDialogComponent, {
    //   panelClass: 'view-camera',
    //   width: '100%',
    //   disableClose: true,
    //   data: { isDevice: true, potentialId: element.vtigerPotentialId, siteName: element.potentialName },
    // });
    // sessionStorage.setItem("potentialId", element.vtigerPotentialId)
  }

  /** Downloads the sites */
  handleDownloadSites(event: any, element: any) {
    this.loading = true;
    this.spinner.activate();
    if (element?.vtigerPotentialId) {
      this.camService.downloadSite(element?.vtigerPotentialId).subscribe(
        (response: any) => {
          this.downloadFile(response, element.vtigerPotentialId);
          this.loading = false;
          this.spinner.deactivate();
          this.toastr.success('File Downloaded successfully.');
        },
        (err) => {
          this.loading = false;
          this.spinner.deactivate();
          this.toastr.error(err.message || 'Internal Server Error');
        }
      );
    }
    /** On click we are creating event in Google Analytics */
    this.googleAnalyticService.event('Download sites', element.potentialName, element.vtigerPotentialId)
    /** End of GA Service  */
  }

  /** The  function for downlaod Excel sheet the sites */
  downloadFile(data: any, potentialId: any) {
    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," });
    const url = window.URL.createObjectURL(blob);
    var anchor = document.createElement("a");
    anchor.download = `${potentialId}.xlsx`;
    anchor.href = url;
    anchor.click();
  }

  /** Get Masking Details methods */
  getMaskingDetails(event: any, element: any) {
    event.stopPropagation();
    // sessionStorage.setItem("siteData", JSON.stringify(element));
    sessionStorage.setItem("potentialId", element?.vtigerPotentialId);
    this.router.navigate([`/camera-server/masking`])
    /** On click we are creating event in Google Analytics */
    this.googleAnalyticService.event('Masking details', element.potentialName, element.vtigerPotentialId)
    /** End of GA Service  */
  }

  /** Site Move to new Camera server */
  handleMoveSiteToNewCS(event: any, element: any) {
    let popupData = {
      title: "Confirmation?",
      message: `Are you sure you want to move Site : ${element.potentialName}, ${element.vtigerPotentialId} to new camera server`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }
    let dialog = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialog.componentInstance._data = popupData;
    dialog.result.then(data => {
      if (data) {
        this.loading = true;
        this.spinner.activate();
        let newPId = [];
        newPId.push(element?.vtigerPotentialId)
        const payload: any = {
          "platform": "NEW_CAMERA_SERVER",
          "potentials": newPId
        }
        this.camService.moveSiteToNewCamServer(payload).subscribe((response: any) => {
          if (response && response.success) {
            this.loading = false;
            this.spinner.deactivate();
            this.toastr.success('Site moved successfully.');
            this.checkCameraServerOldOrNew();
          } else {
            this.loading = false;
            this.spinner.deactivate();
            this.toastr.error(AppConstants.defaultErrorMessage);
          }
        },
          (err) => {
            this.loading = false;
            this.spinner.deactivate();
            this.toastr.error(err.message || AppConstants.defaultErrorMessage);
          }
        );
      } else {
        return;
      }
    });
  }

  /** Show the live view cameras */
  liveView(event: any, element: any) {
    const dialogRef = this.dialog.open(SiteCamLiveViewsComponent, {
      data: element,
      disableClose: true,
      maxWidth: '95vw',
      maxHeight: '95vh',
      width: '100%',
      height: '100%',
      panelClass: 'full-screen-modal'
    });
    /** On click we are creating event in Google Analytics */
    this.googleAnalyticService.event('Live view', element.potentialName, element.vtigerPotentialId)
    /** End of GA Service  */
  }

  /** Navigate to footage download page */
  handleFootageDownload(event: any, element: any) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(FootageDownloadComponent, {
      data: element,
      disableClose: true,
      height: "auto",
      width: "40%"
    });
    /** On click we are creating event in Google Analytics */
    this.googleAnalyticService.event('Open the footage', element.potentialName, element.vtigerPotentialId)
    /** End of GA Service  */
  }

//handle delete site 
handleDeleteSite(data:any){
  const dialogRef = this.dialog.open(ExportDeleteImportComponent,{
    panelClass: 'view-camera',
    width: '50%',
    data: { isEdit: false, response:data },
    disableClose: true
  })
  dialogRef.afterClosed().subscribe((result:any)=>{
    if(result === true){
      setTimeout(() => {
        this.getPagedData(this.pageSize, this.pageNumber, this.searchSiteFilterValue);
      }, 1000);
    }

  })
}

//restoreSite
restoreSite(){
  this.dialog.open(ExportDeleteImportComponent,{
    panelClass: 'view-camera',
    width: '600px',
    data: { isEdit: false, isDeleteSite:true },
    disableClose: true
  })
}
}
